import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { slideInOut } from '../../animations/slideInOut';
import { Action_ApplicationSectionSaved } from '../../state/actions';
import { SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { ErrorResponse } from 'src/app/shared/models/error.model';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { Country, RelationshipType } from 'src/app/shared/models/lookup-data.model';
import {
  ParentLegalcustodianDetails, ParentInfo, ParentDetails,
  ParentDetailsErrors, ParentInfoConfig, ParentDetailsConfig, ParentInfoErrors, ParentErrors
}
  from '../../models/parent-guardian-details';
import { FormService } from 'src/app/shared/services/form.service';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/shared/services/modal.service';
import { compareParentLegalcustodianDetails } from '../../shared/utils/ModelUtils';
import { debounceTime } from 'rxjs/operators';
import { UtilityService } from 'src/app/shared/services/utility.service';


@Component({
  selector: 'online-app-parent-legalcustodian-edit',
  templateUrl: './parent-legalcustodian-edit.component.html',
  styleUrls: ['./parent-legalcustodian-edit.component.scss'],
  host: {
    class: 'application-section-component'
  },
  animations: [slideInOut]
})
export class ParentLegalcustodianEditComponent implements OnInit, OnDestroy {
  parentLegalcustodianFormGroup: FormGroup;
  isFormSubmitted = false;
  applicationId: number;
  parentLegalcustodianId: number;
  isSaveSuccessful = false;
  selectedRelationship = '';
  isScrollDone = false;
  isSubmittedApplication = false;
  showChangeImpactModal: boolean = false;

  isP1ParentDeceased: boolean = false;
  isP2ParentDeceased: boolean = false;
  isSameAddress: boolean = false;

  isParentTheCarer: boolean = null;
  isSingleParent: boolean = false;
  hasLegalCustody: boolean;
  gender: string = '';
  countries: Country[];
  relationships: RelationshipType[] = [];

  isFirstTimeLoad: boolean = false;
  p1ParentDetailsTitle: string = "Parent 1 Details";
  p2ParentDetailsTitle: string = "Parent 2 Details";
  lcParentDetailsTitle: string = "Legal Custodian Details";

  parentErrors: ParentErrors = {};
  p1ParentInfoErrors: ParentInfoErrors = {};
  p2ParentInfoErrors: ParentInfoErrors = {};
  lcParentInfoErrors: ParentInfoErrors = {};
  p1ParentDetailsErrors: ParentDetailsErrors = {};
  p2ParentDetailsErrors: ParentDetailsErrors = {};
  lcParentDetailsErrors: ParentDetailsErrors = {};

  p1ParentInfoConfig: ParentInfoConfig = {
    isSubmittedApplication: null,
    isParentTheCarer: null,
    isParent: true
  }
  p2ParentInfoConfig: ParentInfoConfig = {
    isSubmittedApplication: null,
    isParentTheCarer: null,
    isParent: true
  }
  lcParentInfoConfig: ParentInfoConfig = {
    isSubmittedApplication: null,
    isParentTheCarer: null,
    isParent: false
  }
  p1ParentDetailsConfig: ParentDetailsConfig = {
    isSubmittedApplication: null,
    isParentTheCarer: null,
    isParent: true,
    isSecondParent: false,
    isSameAddress: null,
    isP1ParentDeceased: null
  };
  p2ParentDetailsConfig: ParentDetailsConfig = {
    isSubmittedApplication: null,
    isParentTheCarer: null,
    isParent: true,
    isSecondParent: true,
    isSameAddress: false,
    isP1ParentDeceased: null
  };
  lcParentDetailsConfig: ParentDetailsConfig = {
    isSubmittedApplication: null,
    isParentTheCarer: null,
    isParent: false,
    isSecondParent: false,
    isSameAddress: null,
    isP1ParentDeceased: null
  };


  initialP1ParentInfo: ParentInfo = {
    Relationship: undefined,
    OtherRelationship: undefined,
    IsDeceased: false,
    GivenName: undefined,
    FamilyName: undefined,
    OnlyHasOneName: false,
    HasLegalCustody: undefined
  }
  initialP2ParentInfo: ParentInfo = {
    Relationship: undefined,
    OtherRelationship: undefined,
    IsDeceased: false,
    GivenName: undefined,
    FamilyName: undefined,
    OnlyHasOneName: false,
    HasLegalCustody: undefined
  }
  initialLCParentInfo: ParentInfo = {
    Relationship: undefined,
    OtherRelationship: undefined,
    IsDeceased: false,
    GivenName: undefined,
    FamilyName: undefined,
    OnlyHasOneName: false,
    HasLegalCustody: undefined
  }

  initialP1ParentDetails: ParentDetails = {
    SchoolProgramType: undefined,
    DateOfBirth: undefined,
    Gender: undefined,
    CountryOfBirthId: undefined,
    CountryOfNationalityId: undefined,
    PassportNumber: undefined,
    EmailAddress: undefined,
    Note: undefined,
    IsRefusedAusVisaBefore: undefined,
    VisaRefusalDetails: undefined,
    MobileCountryCode: undefined,
    MobilePhoneNumber: undefined,
    HomeCountryCode: undefined,
    HomePhoneNumber: undefined,
    IsAustralianAddress: false,
    AddressLine1: undefined,
    AddressLine2: undefined,
    SuburbTownCity: undefined,
    StateProvinceRegion: undefined,
    Postcode: undefined,
    CountryId: undefined,
    IsSameAddress: undefined
  }
  initialP2ParentDetails: ParentDetails = {
    SchoolProgramType: undefined,
    DateOfBirth: undefined,
    Gender: undefined,
    CountryOfBirthId: undefined,
    CountryOfNationalityId: undefined,
    PassportNumber: undefined,
    EmailAddress: undefined,
    Note: undefined,
    IsRefusedAusVisaBefore: undefined,
    VisaRefusalDetails: undefined,
    MobileCountryCode: undefined,
    MobilePhoneNumber: undefined,
    HomeCountryCode: undefined,
    HomePhoneNumber: undefined,
    IsAustralianAddress: false,
    AddressLine1: undefined,
    AddressLine2: undefined,
    SuburbTownCity: undefined,
    StateProvinceRegion: undefined,
    Postcode: undefined,
    CountryId: undefined,
    IsSameAddress: undefined
  }
  initialLCParentDetails: ParentDetails = {
    SchoolProgramType: undefined,
    DateOfBirth: undefined,
    Gender: undefined,
    CountryOfBirthId: undefined,
    CountryOfNationalityId: undefined,
    PassportNumber: undefined,
    EmailAddress: undefined,
    Note: undefined,
    IsRefusedAusVisaBefore: undefined,
    VisaRefusalDetails: undefined,
    MobileCountryCode: undefined,
    MobilePhoneNumber: undefined,
    HomeCountryCode: undefined,
    HomePhoneNumber: undefined,
    IsAustralianAddress: false,
    AddressLine1: undefined,
    AddressLine2: undefined,
    SuburbTownCity: undefined,
    StateProvinceRegion: undefined,
    Postcode: undefined,
    CountryId: undefined,
    IsSameAddress: undefined
  }

  p1ParentInfoData: ParentInfo;
  p2ParentInfoData: ParentInfo;
  lcParentInfoData: ParentInfo;

  initialP1ParentInfoData: ParentInfo;
  initialP2ParentInfoData: ParentInfo;
  initialLCParentInfoData: ParentInfo;

  p1ParentDetailsData: ParentDetails;
  p2ParentDetailsData: ParentDetails;
  lcParentDetailsData: ParentDetails;

  initialP1ParentDetailsData: ParentDetails;
  initialP2ParentDetailsData: ParentDetails;
  initialLCParentDetailsData: ParentDetails;

  private subscriptionsToDispose: Subscription[] = [];

  schoolProgramTypeStr: string;

  @ViewChild('resolve') resolve: ElementRef;
  constructor(private formBuilder: FormBuilder,
    private store: Store<any>,
    private applicationService: ApplicationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private formService: FormService,
    private utilityService: UtilityService,
    private modalService: ModalService) {

    this.activatedRoute.parent.parent.params.subscribe(params => {
      this.applicationId = +params['id'];
    });

    this.activatedRoute.parent.params.subscribe(params => {
      this.parentLegalcustodianId = +params['parentLegalcustodianId'];

      if (!this.parentLegalcustodianId) {
        this.parentLegalcustodianId = 0;
      }
    });



    this.applicationService.getApplicationDetails(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        if (response.Result) {
          this.isSubmittedApplication = response.Result.ApplicationStatus === 'Submitted';

          if (this.isSubmittedApplication) {
            this.parentLegalcustodianFormGroup.disable();

            const submittedP1ParentInfoConfig = { ...this.p1ParentInfoConfig };
            submittedP1ParentInfoConfig.isSubmittedApplication = true;
            this.p1ParentInfoConfig = submittedP1ParentInfoConfig;

            const submittedP2ParentInfoConfig = { ...this.p2ParentInfoConfig };
            submittedP2ParentInfoConfig.isSubmittedApplication = true;
            this.p2ParentInfoConfig = submittedP2ParentInfoConfig;

            const submittedLCParentInfoConfig = { ...this.lcParentInfoConfig };
            submittedLCParentInfoConfig.isSubmittedApplication = true;
            this.lcParentInfoConfig = submittedLCParentInfoConfig;

            const submittedP1ParentDetailsConfig = { ...this.p1ParentDetailsConfig };
            submittedP1ParentDetailsConfig.isSubmittedApplication = true;
            this.p1ParentDetailsConfig = submittedP1ParentDetailsConfig;

            const submittedP2ParentDetailsConfig = { ...this.p2ParentDetailsConfig };
            submittedP2ParentDetailsConfig.isSubmittedApplication = true;
            this.p2ParentDetailsConfig = submittedP2ParentDetailsConfig;

            const submittedLCParentDetailsConfig = { ...this.lcParentDetailsConfig };
            submittedLCParentDetailsConfig.isSubmittedApplication = true;
            this.lcParentDetailsConfig = submittedLCParentDetailsConfig;
          }


        }
      }, err => {
        //console.log('getApplicationDetails - error -->', err);
      });


  }


  ngOnInit() {

    this.isSingleParent = false;
    const countries = this.activatedRoute.snapshot.data['countries'];
    this.countries = [this.getDefaultCountry(), ...countries];
    this.relationships = this.activatedRoute.snapshot.data['relationshipTypes'];

    this.parentLegalcustodianFormGroup = this.formBuilder.group({
      isParentTheCarer: null,
      isSingleParent: null,

      p1ParentInfo: this.initialP1ParentInfo,
      p2ParentInfo: this.initialP2ParentInfo,
      legalCustodianInfo: this.initialLCParentInfo,

      p1ParentDetails: this.initialP1ParentDetails,
      p2ParentDetails: this.initialP2ParentDetails,
      legalCustodianDetails: this.initialLCParentDetails
    });

    //Load from Parent/Guardian table to check records. (not from [Student] table)
    this.applicationService.getParentLegalcustodian(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        const parentLegalcustodian = <ParentLegalcustodianDetails>response.Result;

        this.schoolProgramTypeStr = parentLegalcustodian.SchoolProgramType;

        this.isFirstTimeLoad = parentLegalcustodian.P1GivenName || parentLegalcustodian.P2GivenName || parentLegalcustodian.LCGivenName ? false : true;

        //console.log('getParentLegalcustodian - parentLegalcustodian');
        //console.log(parentLegalcustodian);

        this.p1ParentDetailsTitle = this.getParentDetailsTitle(parentLegalcustodian.P1RelationshipCode, parentLegalcustodian.P1GivenName, parentLegalcustodian.P1FamilyName, 'Parent 1');
        this.p2ParentDetailsTitle = this.getParentDetailsTitle(parentLegalcustodian.P2RelationshipCode, parentLegalcustodian.P2GivenName, parentLegalcustodian.P2FamilyName, 'Parent 2');
        this.lcParentDetailsTitle = this.getParentDetailsTitle(parentLegalcustodian.LCRelationshipCode, parentLegalcustodian.LCGivenName, parentLegalcustodian.LCFamilyName, 'Legal Custodian');

        this.isSameAddress = this.isP2AddressSameAsP1Address(parentLegalcustodian);

        const sameAddressP2ParentDetailsConfig = { ...this.p2ParentDetailsConfig };
        sameAddressP2ParentDetailsConfig.isSameAddress = this.isSameAddress;
        this.p2ParentDetailsConfig = sameAddressP2ParentDetailsConfig;

        this.updateFormValuesFromParentLegalcustodian(parentLegalcustodian);
        this.setFromApplicationDetails();
      }, (err) => {
        //console.log('this.applicationService.getParentLegalcustodian() - error');
        console.error(err);
      }
      );

    this.subscriptionsToDispose.push(
      this.parentLegalcustodianFormGroup.get('p1ParentInfo').valueChanges
      .pipe(debounceTime(250))
      .subscribe((data: ParentInfo) => {
        this.p1ParentDetailsTitle = this.getParentDetailsTitle(data.Relationship, data.GivenName, data.FamilyName, 'Parent 1');
        this.isP1ParentDeceased = data.IsDeceased;
  
        const isP1DeceasedP2ParentDetailsConfig = { ...this.p2ParentDetailsConfig };
        isP1DeceasedP2ParentDetailsConfig.isP1ParentDeceased = this.isP1ParentDeceased;
        if (this.isP1ParentDeceased) {
          isP1DeceasedP2ParentDetailsConfig.isSameAddress = false;
        }
        this.p2ParentDetailsConfig = isP1DeceasedP2ParentDetailsConfig;
        //console.log('p1ParentInfo changed - this.p2ParentDetailsConfig: ', this.p2ParentDetailsConfig);
      })
    );
    
    this.subscriptionsToDispose.push(
      this.parentLegalcustodianFormGroup.get('p2ParentInfo').valueChanges
      .pipe(debounceTime(250))
      .subscribe((data: ParentInfo) => {
        this.p2ParentDetailsTitle = this.getParentDetailsTitle(data.Relationship, data.GivenName, data.FamilyName, 'Parent 2');
        this.isP2ParentDeceased = data.IsDeceased;
      })
    );
    
    this.subscriptionsToDispose.push(
      this.parentLegalcustodianFormGroup.get('legalCustodianInfo').valueChanges
      .pipe(debounceTime(250))
      .subscribe((data: ParentInfo) => {
        this.lcParentDetailsTitle = this.getParentDetailsTitle(data.Relationship, data.GivenName, data.FamilyName, 'Legal Custodian');
      })
    );

    this.subscriptionsToDispose.push(
      this.parentLegalcustodianFormGroup.get('p2ParentDetails').valueChanges
      .pipe(debounceTime(250))
      .subscribe((data: ParentDetails) => {
        if (data.IsSameAddress) {
          const p1ParentDetails: ParentDetails = { ...this.parentLegalcustodianFormGroup.get('p1ParentDetails').value };
          if (p1ParentDetails) {
            data.IsAustralianAddress = p1ParentDetails.IsAustralianAddress;
            data.CountryId = p1ParentDetails.CountryId;
            data.AddressLine1 = p1ParentDetails.AddressLine1;
            data.AddressLine2 = p1ParentDetails.AddressLine2;
            data.SuburbTownCity = p1ParentDetails.SuburbTownCity;
            data.StateProvinceRegion = p1ParentDetails.StateProvinceRegion;
            data.Postcode = p1ParentDetails.Postcode;
          }
        }
      })
    );
    
    this.subscriptionsToDispose.push(
      this.parentLegalcustodianFormGroup.get('p1ParentDetails').valueChanges
      .pipe(debounceTime(250))
      .subscribe((data: ParentDetails) => {
        const p2ParentDetails: ParentDetails = { ...this.parentLegalcustodianFormGroup.get('p2ParentDetails').value };
        if (p2ParentDetails && p2ParentDetails.IsSameAddress) {
          const p2ParentDetailsData = { ...this.p2ParentDetailsData };
          p2ParentDetailsData.AddressLine1 = data.AddressLine1;
          p2ParentDetailsData.AddressLine2 = data.AddressLine2;
          p2ParentDetailsData.SuburbTownCity = data.SuburbTownCity;
          p2ParentDetailsData.StateProvinceRegion = data.StateProvinceRegion;
          p2ParentDetailsData.Postcode = data.Postcode;
          p2ParentDetailsData.CountryId = data.CountryId;
          this.p2ParentDetailsData = p2ParentDetailsData;
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptionsToDispose.forEach(s => s.unsubscribe());
  }

  isP2AddressSameAsP1Address(details: ParentLegalcustodianDetails): boolean {
    if (details.P1AddressLine1 || details.P1StateProvinceRegion || details.P1SuburbTownCity ||
      details.P1Postcode || details.P1CountryId) {
      if (details.P1AddressLine1 === details.P2AddressLine1 && details.P1AddressLine2 === details.P2AddressLine2 &&
        details.P1SuburbTownCity === details.P2SuburbTownCity && details.P1SuburbTownCity === details.P2SuburbTownCity &&
        details.P1StateProvinceRegion === details.P2StateProvinceRegion && details.P1Postcode === details.P2Postcode &&
        details.P1CountryId === details.P2CountryId) {
        return true;
      }
    }
    return false;
  }

  getParentDetailsTitle(relationshipCode: string, givenName: string, familyName: string, defaultRelationTitle: string): string {
    let relationship = defaultRelationTitle;
    if (relationshipCode) {
      let relCode = this.relationships.find(r => r.Code == relationshipCode);
      if (relCode) {
        relationship = relCode.Description;
      } else {
        relCode = this.relationships.find(r => r.Description == relationshipCode);
        relationship = relCode ? relationshipCode : relationship;
      }
    }
    let fullName = givenName ? givenName : "";
    fullName = familyName ? fullName + " " + familyName : fullName;
    fullName = fullName ? fullName : "Details";

    return relationship + ': ' + fullName;
  }

  setFromApplicationDetails() {
    this.applicationService.getApplicationDetails(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        if (response.Result) {
          if (this.isFirstTimeLoad) {
            this.presetParentLCValue(response.Result.Student);
          }
          this.isSubmittedApplication = response.Result.ApplicationStatus === 'Submitted';
          // console.log('this.isSubmittedApplication: edit page', this.isSubmittedApplication);
          // this.p1ParentInfoConfig.isSubmittedApplication = this.isSubmittedApplication;
          // this.p2ParentInfoConfig.isSubmittedApplication = this.isSubmittedApplication;
          // this.lcParentInfoConfig.isSubmittedApplication = this.isSubmittedApplication;
          // this.p1ParentDetailsConfig.isSubmittedApplication = this.isSubmittedApplication;
          // this.p2ParentDetailsConfig.isSubmittedApplication = this.isSubmittedApplication;
          // this.lcParentDetailsConfig.isSubmittedApplication = this.isSubmittedApplication;

          if (this.isSubmittedApplication) {
            this.parentLegalcustodianFormGroup.disable();
          }
        }
      }, err => {
        //console.log('getApplicationDetails - error -->', err);
      });
  }


  presetParentLCValue(studentInfo: any) {
    //console.log('presetParentLCValue - studentInfo')
    //console.log(studentInfo);
    if (studentInfo.LegalCustodianGivenName) {
      //Student already set Legal Custodian
      this.isParentTheCarer = false;
      this.updateParentAsCarer(false);

      this.lcParentInfoData.GivenName = studentInfo.LegalCustodianGivenName;
      if (studentInfo.LegalCustodianFamilyName) {
        this.lcParentInfoData.FamilyName = studentInfo.LegalCustodianFamilyName;
      }
    }
    else {
      this.isParentTheCarer = true;
      this.updateParentAsCarer(true);
      if (studentInfo.Parent1GivenName) {
        this.p1ParentInfoData.GivenName = studentInfo.Parent1GivenName;
        if (studentInfo.Parent1FamilyName) {
          this.p1ParentInfoData.FamilyName = studentInfo.Parent1FamilyName;
        }
        this.p1ParentInfoData.Relationship = studentInfo.Parent1Relationship;

        if (studentInfo.Parent2GivenName) {
          this.isSingleParent = false;
          this.p2ParentInfoData.GivenName = studentInfo.Parent2GivenName;
          if (studentInfo.Parent2FamilyName) {
            this.p2ParentInfoData.FamilyName = studentInfo.Parent2FamilyName;
          }
          this.p2ParentInfoData.Relationship = studentInfo.Parent2Relationship;
        }
        else {
          this.isSingleParent = true;
        }
      }
    }
    console.info("this.isSingleParent", this.isSingleParent);
    //console.log("P1/2/LC data 4 re-binding is:", this.p1ParentInfoData, this.p2ParentInfoData, this.lcParentInfoData);
    this.parentLegalcustodianFormGroup.patchValue({
      p1ParentInfo: this.p1ParentInfoData,
      p2ParentInfo: this.p2ParentInfoData,
      legalCustodianInfo: this.lcParentInfoData
    });

    this.parentLegalcustodianFormGroup.updateValueAndValidity();
  }


  getDefaultCountry(): Country {
    return {
      Id: '',
      Code: '',
      Description: 'Please select',
      Status: '',
      IsAgentMandatory: false,
      CanStudyAbroad: false,
      PhoneCode: 0,
      IsDeleted: false
    };
  }

  reloadInitialData() {
    this.applicationService.getParentLegalcustodian(this.applicationId)
      .subscribe((response: SingleResultApiResponse) => {
        this.updateInitialData(response.Result);
      }, err => {
        //console.log('reloadInitialData error');
        //console.error(err);
      });
  }

  updateInitialData(parentLegalcustodianDetails: ParentLegalcustodianDetails): void {

    const p1ParentInfoData = this.getP1ParentInfoFromParentLegalcustodian(parentLegalcustodianDetails);
    this.p1ParentInfoConfig.ParentId = parentLegalcustodianDetails.P1ParentId;

    const p2ParentInfoData = this.getP2ParentInfoFromParentLegalcustodian(parentLegalcustodianDetails);
    this.p2ParentInfoConfig.ParentId = parentLegalcustodianDetails.P2ParentId;

    const lcParentInfoData = this.getLCParentInfoFromParentLegalcustodian(parentLegalcustodianDetails);
    this.lcParentInfoConfig.ParentId = parentLegalcustodianDetails.LCParentId;

    const p1ParentDetailsData = this.getP1ParentDetailsFromParentLegalcustodian(parentLegalcustodianDetails);
    const p2ParentDetailsData = this.getP2ParentDetailsFromParentLegalcustodian(parentLegalcustodianDetails);
    const lcParentDetailsData = this.getLCParentDetailsFromParentLegalcustodian(parentLegalcustodianDetails);

    this.initialP1ParentInfoData = { ...p1ParentInfoData };
    this.initialP2ParentInfoData = { ...p2ParentInfoData };
    this.initialLCParentInfoData = { ...lcParentInfoData };

    this.initialP1ParentDetailsData = { ...p1ParentDetailsData };
    this.initialP2ParentDetailsData = { ...p2ParentDetailsData };
    this.initialLCParentDetailsData = { ...lcParentDetailsData };
  }

  getP1ParentInfoFromParentLegalcustodian(parent: ParentLegalcustodianDetails): ParentInfo {

    return {
      Relationship: parent.P1RelationshipCode,
      OtherRelationship: undefined,
      IsDeceased: parent.P1IsDeceased,
      GivenName: parent.P1GivenName,
      FamilyName: parent.P1FamilyName,
      OnlyHasOneName: parent.P1OnlyHasOneName,
      HasLegalCustody: parent.P1HasLegalCustody
    };
  }
  getP2ParentInfoFromParentLegalcustodian(parent: ParentLegalcustodianDetails): ParentInfo {

    return {
      Relationship: parent.P2RelationshipCode,
      OtherRelationship: undefined,
      IsDeceased: parent.P2IsDeceased,
      GivenName: parent.P2GivenName,
      FamilyName: parent.P2FamilyName,
      OnlyHasOneName: parent.P2OnlyHasOneName,
      HasLegalCustody: parent.P2HasLegalCustody
    };
  }
  getLCParentInfoFromParentLegalcustodian(lc: ParentLegalcustodianDetails): ParentInfo {

    return {
      Relationship: lc.LCRelationshipCode,
      OtherRelationship: lc.LCOtherRelationship,
      IsDeceased: false,
      GivenName: lc.LCGivenName,
      FamilyName: lc.LCFamilyName,
      OnlyHasOneName: lc.LCOnlyHasOneName,
      HasLegalCustody: true
    };
  }

  getP1ParentDetailsFromParentLegalcustodian(parent: ParentLegalcustodianDetails): ParentDetails {
    return {
      SchoolProgramType: this.schoolProgramTypeStr,
      DateOfBirth: parent.P1DateOfBirth,
      Gender: parent.P1Gender,
      CountryOfBirthId: parent.P1CountryOfBirthId,
      CountryOfNationalityId: parent.P1CountryOfNationalityId,
      PassportNumber: parent.P1PassportNumber,
      EmailAddress: parent.P1EmailAddress,
      Note: parent.P1Note,
      IsRefusedAusVisaBefore: parent.P1IsRefusedAusVisaBefore,
      VisaRefusalDetails: parent.P1VisaRefusalDetails,
      MobileCountryCode: parent.P1MobileCountryCode,
      MobilePhoneNumber: parent.P1MobilePhoneNumber,
      HomeCountryCode: parent.P1HomeCountryCode,
      HomePhoneNumber: parent.P1HomePhoneNumber,
      IsAustralianAddress: parent.P1IsAustralianAddress,
      AddressLine1: parent.P1AddressLine1,
      AddressLine2: parent.P1AddressLine2,
      SuburbTownCity: parent.P1SuburbTownCity,
      StateProvinceRegion: parent.P1StateProvinceRegion,
      Postcode: parent.P1Postcode,
      CountryId: parent.P1CountryId,
      IsSameAddress: false
    };
  }
  getP2ParentDetailsFromParentLegalcustodian(parent: ParentLegalcustodianDetails): ParentDetails {
    return {
      SchoolProgramType: this.schoolProgramTypeStr,
      DateOfBirth: parent.P2DateOfBirth,
      Gender: parent.P2Gender,
      CountryOfBirthId: parent.P2CountryOfBirthId,
      CountryOfNationalityId: parent.P2CountryOfNationalityId,
      PassportNumber: parent.P2PassportNumber,
      EmailAddress: parent.P2EmailAddress,
      Note: parent.P2Note,
      IsRefusedAusVisaBefore: parent.P2IsRefusedAusVisaBefore,
      VisaRefusalDetails: parent.P2VisaRefusalDetails,
      MobileCountryCode: parent.P2MobileCountryCode,
      MobilePhoneNumber: parent.P2MobilePhoneNumber,
      HomeCountryCode: parent.P2HomeCountryCode,
      HomePhoneNumber: parent.P2HomePhoneNumber,
      IsAustralianAddress: parent.P2IsAustralianAddress,
      AddressLine1: parent.P2AddressLine1,
      AddressLine2: parent.P2AddressLine2,
      SuburbTownCity: parent.P2SuburbTownCity,
      StateProvinceRegion: parent.P2StateProvinceRegion,
      Postcode: parent.P2Postcode,
      CountryId: parent.P2CountryId,
      IsSameAddress: false
    };
  }
  getLCParentDetailsFromParentLegalcustodian(lc: ParentLegalcustodianDetails): ParentDetails {
    return {
      SchoolProgramType: this.schoolProgramTypeStr,
      DateOfBirth: lc.LCDateOfBirth,
      Gender: lc.LCGender,
      CountryOfBirthId: lc.LCCountryOfBirthId,
      CountryOfNationalityId: lc.LCCountryOfNationalityId,
      PassportNumber: lc.LCPassportNumber,
      EmailAddress: lc.LCEmailAddress,
      Note: lc.LCNote,
      IsRefusedAusVisaBefore: lc.LCIsRefusedAusVisaBefore,
      VisaRefusalDetails: lc.LCVisaRefusalDetails,
      MobileCountryCode: lc.LCMobileCountryCode,
      MobilePhoneNumber: lc.LCMobilePhoneNumber,
      HomeCountryCode: lc.LCHomeCountryCode,
      HomePhoneNumber: lc.LCHomePhoneNumber,
      IsAustralianAddress: lc.LCIsAustralianAddress,
      AddressLine1: lc.LCAddressLine1,
      AddressLine2: lc.LCAddressLine2,
      SuburbTownCity: lc.LCSuburbTownCity,
      StateProvinceRegion: lc.LCStateProvinceRegion,
      Postcode: lc.LCPostcode,
      CountryId: lc.LCCountryId,
      IsSameAddress: false
    };
  }


  updateFormValuesFromParentLegalcustodian(parentLegalCustodian: ParentLegalcustodianDetails): void {
    this.isParentTheCarer = parentLegalCustodian.IsParentTheCarer;
    this.isSingleParent = parentLegalCustodian.IsSingleParent;
    console.info("this.isSingleParent", this.isSingleParent);
    this.p1ParentInfoConfig.isParentTheCarer = parentLegalCustodian.IsParentTheCarer;
    this.p2ParentInfoConfig.isParentTheCarer = parentLegalCustodian.IsParentTheCarer;
    this.lcParentInfoConfig.isParentTheCarer = parentLegalCustodian.IsParentTheCarer;
    this.p1ParentDetailsConfig.isParentTheCarer = parentLegalCustodian.IsParentTheCarer;
    this.p2ParentDetailsConfig.isParentTheCarer = parentLegalCustodian.IsParentTheCarer;
    this.lcParentDetailsConfig.isParentTheCarer = parentLegalCustodian.IsParentTheCarer;
    this.p1ParentInfoConfig.ParentId = parentLegalCustodian.P1ParentId;
    this.p2ParentInfoConfig.ParentId = parentLegalCustodian.P2ParentId;
    this.lcParentInfoConfig.ParentId = parentLegalCustodian.LCParentId;

    this.p1ParentInfoData = this.getP1ParentInfoFromParentLegalcustodian(parentLegalCustodian);
    this.p2ParentInfoData = this.getP2ParentInfoFromParentLegalcustodian(parentLegalCustodian);
    this.lcParentInfoData = this.getLCParentInfoFromParentLegalcustodian(parentLegalCustodian);

    this.p1ParentDetailsData = this.getP1ParentDetailsFromParentLegalcustodian(parentLegalCustodian);
    this.p2ParentDetailsData = this.getP2ParentDetailsFromParentLegalcustodian(parentLegalCustodian);
    this.lcParentDetailsData = this.getLCParentDetailsFromParentLegalcustodian(parentLegalCustodian);

    this.initialP1ParentInfoData = { ...this.p1ParentInfoData };
    this.initialP2ParentInfoData = { ...this.p2ParentInfoData };
    this.initialLCParentInfoData = { ...this.lcParentInfoData };

    this.initialP1ParentDetailsData = { ...this.p1ParentDetailsData };
    this.initialP2ParentDetailsData = { ...this.p2ParentDetailsData };
    this.initialLCParentDetailsData = { ...this.lcParentDetailsData };

    this.parentLegalcustodianFormGroup.patchValue({
      p1ParentInfo: this.p1ParentInfoData,
      p2ParentInfo: this.p2ParentInfoData,
      legalCustodianInfo: this.lcParentInfoData,

      p1ParentDetails: this.p1ParentDetailsData,
      p2ParentDetails: this.p2ParentDetailsData,
      legalCustodianDetails: this.lcParentDetailsData
    });

    this.parentLegalcustodianFormGroup.updateValueAndValidity();
  }



  getParentLegalcustodian(): ParentLegalcustodianDetails {
    const parentLegalcustodian = new ParentLegalcustodianDetails();

    parentLegalcustodian.SchoolProgramType = this.schoolProgramTypeStr;
    parentLegalcustodian.P1ParentId = this.parentLegalcustodianId;
    parentLegalcustodian.IsParentTheCarer = this.isParentTheCarer;
    parentLegalcustodian.IsSingleParent = this.isSingleParent;
    this.p1ParentInfoConfig.isParentTheCarer = this.isParentTheCarer;
    this.p2ParentInfoConfig.isParentTheCarer = this.isParentTheCarer;
    this.lcParentInfoConfig.isParentTheCarer = this.isParentTheCarer;

    const p1ParentInfo = this.parentLegalcustodianFormGroup.get('p1ParentInfo').value;
    this.updateP1ParentInfo(parentLegalcustodian, p1ParentInfo);

    if (!this.isSingleParent) {
      const p2ParentInfo = this.parentLegalcustodianFormGroup.get('p2ParentInfo').value;
      this.updateP2ParentInfo(parentLegalcustodian, p2ParentInfo);
    }

    const legalCustodianInfo = this.parentLegalcustodianFormGroup.get('legalCustodianInfo').value;
    this.updateLegalCustodianInfo(parentLegalcustodian, legalCustodianInfo);

    const p1ParentDetails = this.parentLegalcustodianFormGroup.get('p1ParentDetails').value;
    this.updateP1ParentDetails(parentLegalcustodian, p1ParentDetails);

    if (!this.isSingleParent) {
      const p2ParentDetails = this.parentLegalcustodianFormGroup.get('p2ParentDetails').value;
      //console.log('this.parentLegalcustodianFormGroup.get(p2ParentDetails).value: ', p2ParentDetails)
      this.updateP2ParentDetails(parentLegalcustodian, p2ParentDetails);
    }

    const legalCustodianDetails = this.parentLegalcustodianFormGroup.get('legalCustodianDetails').value;
    this.updateLegalCustodianDetails(parentLegalcustodian, legalCustodianDetails);

    parentLegalcustodian.P1ParentId = this.p1ParentInfoConfig.ParentId;
    parentLegalcustodian.P2ParentId = !this.isSingleParent ? this.p2ParentInfoConfig.ParentId : 0;
    parentLegalcustodian.LCParentId = this.lcParentInfoConfig.ParentId;

    return parentLegalcustodian;
  }

  updateP1ParentInfo(info: ParentLegalcustodianDetails, parentInfo: ParentInfo): void {
    info.P1RelationshipCode = parentInfo.Relationship;
    info.P1GivenName = parentInfo.GivenName;
    info.P1FamilyName = parentInfo.FamilyName;
    info.P1OnlyHasOneName = parentInfo.OnlyHasOneName;
    info.P1IsDeceased = parentInfo.IsDeceased;
    info.P1HasLegalCustody = parentInfo.HasLegalCustody;
  }

  updateP2ParentInfo(info: ParentLegalcustodianDetails, parentInfo: ParentInfo): void {
    info.P2RelationshipCode = parentInfo.Relationship;
    info.P2GivenName = parentInfo.GivenName;
    info.P2FamilyName = parentInfo.FamilyName;
    info.P2OnlyHasOneName = parentInfo.OnlyHasOneName;
    info.P2IsDeceased = parentInfo.IsDeceased;
    info.P2HasLegalCustody = parentInfo.HasLegalCustody;
  }

  updateLegalCustodianInfo(info: ParentLegalcustodianDetails, parentInfo: ParentInfo): void {
    info.LCRelationshipCode = parentInfo.Relationship;
    info.LCOtherRelationship = parentInfo.OtherRelationship;
    info.LCGivenName = parentInfo.GivenName;
    info.LCFamilyName = parentInfo.FamilyName;
    info.LCOnlyHasOneName = parentInfo.OnlyHasOneName;
  }

  updateP1ParentDetails(details: ParentLegalcustodianDetails, parentDetails: ParentDetails): void {
    details.P1DateOfBirth = this.utilityService.getDateStrWithoutTimeZone(parentDetails.DateOfBirth);
    details.P1Gender = parentDetails.Gender;
    details.P1CountryOfBirthId = parentDetails.CountryOfBirthId;
    details.P1CountryOfNationalityId = parentDetails.CountryOfNationalityId;
    details.P1PassportNumber = parentDetails.PassportNumber;
    details.P1EmailAddress = parentDetails.EmailAddress;
    details.P1Note = parentDetails.Note;
    details.P1IsRefusedAusVisaBefore = parentDetails.IsRefusedAusVisaBefore;
    details.P1VisaRefusalDetails = parentDetails.VisaRefusalDetails;
    details.P1MobileCountryCode = parentDetails.MobileCountryCode;
    details.P1MobilePhoneNumber = parentDetails.MobilePhoneNumber;
    details.P1HomeCountryCode = parentDetails.HomeCountryCode;
    details.P1HomePhoneNumber = parentDetails.HomePhoneNumber;
    details.P1IsAustralianAddress = parentDetails.IsAustralianAddress;
    details.P1AddressLine1 = parentDetails.AddressLine1;
    details.P1AddressLine2 = parentDetails.AddressLine2;
    details.P1SuburbTownCity = parentDetails.SuburbTownCity;
    details.P1StateProvinceRegion = parentDetails.StateProvinceRegion;
    details.P1Postcode = parentDetails.Postcode;
    details.P1CountryId = parentDetails.CountryId;
  }
  updateP2ParentDetails(details: ParentLegalcustodianDetails, parentDetails: ParentDetails): void {
    details.P2DateOfBirth = this.utilityService.getDateStrWithoutTimeZone(parentDetails.DateOfBirth);
    details.P2Gender = parentDetails.Gender;
    details.P2CountryOfBirthId = parentDetails.CountryOfBirthId;
    details.P2CountryOfNationalityId = parentDetails.CountryOfNationalityId;
    details.P2PassportNumber = parentDetails.PassportNumber;
    details.P2EmailAddress = parentDetails.EmailAddress;
    details.P2Note = parentDetails.Note;
    details.P2IsRefusedAusVisaBefore = parentDetails.IsRefusedAusVisaBefore;
    details.P2VisaRefusalDetails = parentDetails.VisaRefusalDetails;
    details.P2MobileCountryCode = parentDetails.MobileCountryCode;
    details.P2MobilePhoneNumber = parentDetails.MobilePhoneNumber;
    details.P2HomeCountryCode = parentDetails.HomeCountryCode;
    details.P2HomePhoneNumber = parentDetails.HomePhoneNumber;

    details.P2IsAustralianAddress = parentDetails.IsAustralianAddress;
    details.P2AddressLine1 = parentDetails.AddressLine1;
    details.P2AddressLine2 = parentDetails.AddressLine2;
    details.P2SuburbTownCity = parentDetails.SuburbTownCity;
    details.P2StateProvinceRegion = parentDetails.StateProvinceRegion;
    details.P2Postcode = parentDetails.Postcode;
    details.P2CountryId = parentDetails.CountryId;
  }
  updateLegalCustodianDetails(details: ParentLegalcustodianDetails, parentDetails: ParentDetails): void {
    details.LCDateOfBirth = this.utilityService.getDateStrWithoutTimeZone(parentDetails.DateOfBirth);
    details.LCGender = parentDetails.Gender;
    details.LCCountryOfBirthId = parentDetails.CountryOfBirthId;
    details.LCCountryOfNationalityId = parentDetails.CountryOfNationalityId;
    details.LCPassportNumber = parentDetails.PassportNumber;
    details.LCEmailAddress = parentDetails.EmailAddress;
    details.LCNote = parentDetails.Note;
    details.LCIsRefusedAusVisaBefore = parentDetails.IsRefusedAusVisaBefore;
    details.LCVisaRefusalDetails = parentDetails.VisaRefusalDetails;
    details.LCMobileCountryCode = parentDetails.MobileCountryCode;
    details.LCMobilePhoneNumber = parentDetails.MobilePhoneNumber;
    details.LCHomeCountryCode = parentDetails.HomeCountryCode;
    details.LCHomePhoneNumber = parentDetails.HomePhoneNumber;
    details.LCIsAustralianAddress = parentDetails.IsAustralianAddress;
    details.LCAddressLine1 = parentDetails.AddressLine1;
    details.LCAddressLine2 = parentDetails.AddressLine2;
    details.LCSuburbTownCity = parentDetails.SuburbTownCity;
    details.LCStateProvinceRegion = parentDetails.StateProvinceRegion;
    details.LCPostcode = parentDetails.Postcode;
    details.LCCountryId = parentDetails.CountryId;
  }

  saveParentLegalcustodian() {

    const parentLegalcustodian = this.getParentLegalcustodian();



    this.isFormSubmitted = true;
    //console.log('saveParentLegalcustodian - parentLegalcustodian');
    //console.log(parentLegalcustodian);

    this.applicationService.updateParentLegalcustodian(this.applicationId, parentLegalcustodian)
      .subscribe((response: SingleResultApiResponse) => {
        //console.log('response of saveParentLegalcustodian');
        //console.log(response);
        this.dispatchSectionSaveAction();
        this.isSaveSuccessful = true;

        if (response.Result) {
          this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
        }

      }, (errorResponse: ErrorResponse) => {
        //console.log('ErrorResponse of saveParentLegalcustodian');
        //console.log(errorResponse);

        let p1ParentInfoErrors: ParentInfoErrors = {};
        let p2ParentInfoErrors: ParentInfoErrors = {};
        let lcParentInfoErrors: ParentInfoErrors = {};
        let p1ParentDetailsErrors: ParentDetailsErrors = {};
        let p2ParentDetailsErrors: ParentDetailsErrors = {};
        let lcParentDetailsErrors: ParentDetailsErrors = {};
        const { errors, result } = errorResponse;

        for (const error of errors) {
          this.setApiValidationError(error.Key,
            error.Value,
            p1ParentInfoErrors,
            p2ParentInfoErrors,
            lcParentInfoErrors,
            p1ParentDetailsErrors,
            p2ParentDetailsErrors,
            lcParentDetailsErrors
          );
        }

        this.p1ParentInfoErrors = p1ParentInfoErrors;
        this.p2ParentInfoErrors = p2ParentInfoErrors;
        this.lcParentInfoErrors = lcParentInfoErrors;
        this.p1ParentDetailsErrors = p1ParentDetailsErrors;
        this.p2ParentDetailsErrors = p2ParentDetailsErrors;
        this.lcParentDetailsErrors = lcParentDetailsErrors;

        this.parentLegalcustodianFormGroup.updateValueAndValidity();
        this.dispatchSectionSaveAction();
        this.reloadInitialData();
        this.isScrollDone = false;
        this.formService.scrollToFirstErrorField();
      });

  }

  dispatchSectionSaveAction() {
    this.store.dispatch({
      type: Action_ApplicationSectionSaved
    });
  }

  ngAfterContentChecked(): void {
    if (!this.isScrollDone) {
      this.isScrollDone = this.formService.scrollToFirstErrorField();
    }

  }

  // canDeactivate(): Observable<boolean> | boolean {

  //   if (this.isSaveSuccessful) {
  //     return true;
  //   }

  //   // if (!this.isParentLegalcustodianDataSame()) {
  //   //   this.modalService.showModal();
  //   //   return this.modalService.stayOnThePage;
  //   // } else {
  //   //   this.modalService.hideModal();
  //   //   return true;
  //   // }
  // }

  isParentLegalcustodianDataSame(): boolean {
    const currentP1ParentInfo = this.parentLegalcustodianFormGroup.get('p1ParentInfo').value;
    const currentP2ParentInfo = this.parentLegalcustodianFormGroup.get('p2ParentInfo').value;
    const currentLCParentInfo = this.parentLegalcustodianFormGroup.get('legalCustodianInfo').value;

    const currentP1ParentDetails = this.parentLegalcustodianFormGroup.get('p1ParentDetails').value;
    const currentP2ParentDetails = this.parentLegalcustodianFormGroup.get('p2ParentDetails').value;
    const currentLCParentDetails = this.parentLegalcustodianFormGroup.get('legalCustodianDetails').value;



    const isParentLegalcustodianDataSame = compareParentLegalcustodianDetails(
      this.initialP1ParentInfo, currentP1ParentInfo,
      this.initialP2ParentInfo, currentP2ParentInfo,
      this.initialLCParentInfo, currentLCParentInfo,
      this.initialP1ParentDetails, currentP1ParentDetails,
      this.initialP2ParentDetails, currentP2ParentDetails,
      this.initialLCParentDetails, currentLCParentDetails
    )

    return isParentLegalcustodianDataSame;
  }

  /*
  p1ParentInfo: this.initialP1ParentInfo,
  p2ParentInfo: this.initialP2ParentInfo,
  legalCustodianInfo: this.initialLCParentInfo,

  p1ParentDetails: this.initialP1ParentDetails,
  p2ParentDetails: this.initialP2ParentDetails,
  legalCustodianDetails: this.initialLCParentDetails
  */


  // isParentGuardianDetailsSame(): boolean {
  //   const currentPersonDetails = this.parentGuardianDetailsFormGroup.get('parentDetails').value;
  //   const currentPhoneNumberDetails = this.parentGuardianDetailsFormGroup.get('phoneNumber').value;
  //   const currentAustralianAddressDetails = this.parentGuardianDetailsFormGroup.get('australianAddress').value;
  //   const currentOverseasAddressDetails = this.parentGuardianDetailsFormGroup.get('overseasAddress').value;

  //   const isParentGuardianDetailsSame = compareParentGuardianDetails(this.initialParentDetailsData, currentPersonDetails,
  //                         this.initialPhoneNumberData, currentPhoneNumberDetails,
  //                         this.initialAustralianAddressData, currentAustralianAddressDetails,
  //                         this.initialOverseasAddressData, currentOverseasAddressDetails);

  //   return isParentGuardianDetailsSame;
  // }



  cancelSaveParentGuardian(): void {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
  }


  displayChangeImpactModal(): boolean {
    return this.showChangeImpactModal;
  }

  onCloseModal() {
    this.showChangeImpactModal = false;
    this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
  }

  relationshipUpdate() {
  }

  isSingleParentClicked(event) {
    this.isSingleParent = event.checked;
  }

  updateParentAsCarer(isParentTheCarer: boolean) {
    this.isParentTheCarer = isParentTheCarer;
    this.parentErrors.IsParentTheCarer = '';
    //console.log('updateParentAsCarer - isParentTheCarer');
    //console.log(this.isParentTheCarer);
    this.p1ParentInfoConfig.isParentTheCarer = this.isParentTheCarer;
    this.p2ParentInfoConfig.isParentTheCarer = this.isParentTheCarer;
    this.lcParentInfoConfig.isParentTheCarer = this.isParentTheCarer;
    this.p1ParentDetailsConfig.isParentTheCarer = this.isParentTheCarer;
    this.p2ParentDetailsConfig.isParentTheCarer = this.isParentTheCarer;
    this.lcParentDetailsConfig.isParentTheCarer = this.isParentTheCarer;
    this.parentLegalcustodianFormGroup.patchValue({
      isParentTheCarer
    });
    this.parentLegalcustodianFormGroup.updateValueAndValidity();
  }

  updateLegalCustody(hasLegalCustody: boolean) {
    this.hasLegalCustody = hasLegalCustody;

    this.parentLegalcustodianFormGroup.patchValue({
      hasLegalCustody
    });
    this.parentLegalcustodianFormGroup.updateValueAndValidity();
  }

  getInfoSectionTitle() {
    //console.log('getInfoSectionTitle');
    //console.log(this.isParentTheCarer);
    if (this.isParentTheCarer === false) {
      return "Legal Custodian Info";
    }
    return "Parent Info";
  }

  setApiValidationError(apiErrorKeyName: string,
    apiErrorMsg: string,
    p1ParentInfoErrors: ParentInfoErrors,
    p2ParentInfoErrors: ParentInfoErrors,
    lcParentInfoErrors: ParentInfoErrors,
    p1ParentDetailsErrors: ParentDetailsErrors,
    p2ParentDetailsErrors: ParentDetailsErrors,
    lcParentDetailsErrors: ParentDetailsErrors,
  ): void {
    switch (apiErrorKeyName) {
      case 'IsParentTheCarer':
        this.parentErrors.IsParentTheCarer = apiErrorMsg;
        break;
      //Parent 1
      case 'P1RelationshipCode':
        p1ParentInfoErrors.Relationship = apiErrorMsg;
        break;
      case 'P1IsDeceased':
        p1ParentInfoErrors.IsDeceased = apiErrorMsg;
        break;
      case 'P1GivenName':
        p1ParentInfoErrors.GivenName = apiErrorMsg;
        break;
      case 'P1FamilyName':
        p1ParentInfoErrors.FamilyName = apiErrorMsg;
        break;
      case 'P1HasLegalCustody':
        p1ParentInfoErrors.HasLegalCustody = apiErrorMsg;
        break;

      case 'P1IsRefusedAusVisaBefore':
        p1ParentDetailsErrors.IsRefusedAusVisaBefore = apiErrorMsg;
        break;
      case 'P1VisaRefusalDetails':
        p1ParentDetailsErrors.VisaRefusalDetails = apiErrorMsg;
        break;
      case 'P1Gender':
        p1ParentDetailsErrors.Gender = apiErrorMsg;
        break;
      case 'P1DateOfBirth':
        p1ParentDetailsErrors.DateOfBirth = apiErrorMsg;
        break;
      case 'P1CountryOfBirthId':
        p1ParentDetailsErrors.CountryOfBirthId = apiErrorMsg;
        break;
      case 'P1CountryOfNationalityId':
        p1ParentDetailsErrors.CountryOfNationalityId = apiErrorMsg;
        break;
      case 'P1PassportNumber':
        p1ParentDetailsErrors.PassportNumber = apiErrorMsg;
        break;
      case 'P1EmailAddress':
        p1ParentDetailsErrors.EmailAddress = apiErrorMsg;
        break;
      case 'P1MobileCountryCode':
        p1ParentDetailsErrors.MobileCountryCode = apiErrorMsg;
        break;
      case 'P1MobilePhoneNumber':
        p1ParentDetailsErrors.MobilePhoneNumber = apiErrorMsg;
        break;
      case 'P1HomeCountryCode':
        p1ParentDetailsErrors.HomeCountryCode = apiErrorMsg;
        break;
      case 'P1HomePhoneNumber':
        p1ParentDetailsErrors.HomePhoneNumber = apiErrorMsg;
        break;
      case 'P1IsAustralianAddress':
        p1ParentDetailsErrors.IsAustralianAddress = apiErrorMsg;
        break;
      case 'P1AddressLine1':
        p1ParentDetailsErrors.AddressLine1 = apiErrorMsg;
        break;
      case 'P1AddressLine2':
        p1ParentDetailsErrors.AddressLine2 = apiErrorMsg;
        break;
      case 'P1SuburbTownCity':
        p1ParentDetailsErrors.SuburbTownCity = apiErrorMsg;
        break;
      case 'P1StateProvinceRegion':
        p1ParentDetailsErrors.StateProvinceRegion = apiErrorMsg;
        break;
      case 'P1Postcode':
        p1ParentDetailsErrors.Postcode = apiErrorMsg;
        break;
      case 'P1CountryId':
        p1ParentDetailsErrors.CountryId = apiErrorMsg;
        break;


      //Parent 2
      case 'P2RelationshipCode':
        p2ParentInfoErrors.Relationship = apiErrorMsg;
        break;
      case 'P2IsDeceased':
        p2ParentInfoErrors.IsDeceased = apiErrorMsg;
        break;
      case 'P2GivenName':
        p2ParentInfoErrors.GivenName = apiErrorMsg;
        break;
      case 'P2FamilyName':
        p2ParentInfoErrors.FamilyName = apiErrorMsg;
        break;
      case 'P2HasLegalCustody':
        p2ParentInfoErrors.HasLegalCustody = apiErrorMsg;
        break;

      case 'P2IsRefusedAusVisaBefore':
        p2ParentDetailsErrors.IsRefusedAusVisaBefore = apiErrorMsg;
        break;
      case 'P2VisaRefusalDetails':
        p2ParentDetailsErrors.VisaRefusalDetails = apiErrorMsg;
        break;
      case 'P2Gender':
        p2ParentDetailsErrors.Gender = apiErrorMsg;
        break;
      case 'P2DateOfBirth':
        p2ParentDetailsErrors.DateOfBirth = apiErrorMsg;
        break;
      case 'P2CountryOfBirthId':
        p2ParentDetailsErrors.CountryOfBirthId = apiErrorMsg;
        break;
      case 'P2CountryOfNationalityId':
        p2ParentDetailsErrors.CountryOfNationalityId = apiErrorMsg;
        break;
      case 'P2PassportNumber':
        p2ParentDetailsErrors.PassportNumber = apiErrorMsg;
        break;
      case 'P2EmailAddress':
        p2ParentDetailsErrors.EmailAddress = apiErrorMsg;
        break;
      case 'P2MobileCountryCode':
        p2ParentDetailsErrors.MobileCountryCode = apiErrorMsg;
        break;
      case 'P2MobilePhoneNumber':
        p2ParentDetailsErrors.MobilePhoneNumber = apiErrorMsg;
        break;
      case 'P2HomeCountryCode':
        p2ParentDetailsErrors.HomeCountryCode = apiErrorMsg;
        break;
      case 'P2HomePhoneNumber':
        p2ParentDetailsErrors.HomePhoneNumber = apiErrorMsg;
        break;
      case 'P2IsAustralianAddress':
        p2ParentDetailsErrors.IsAustralianAddress = apiErrorMsg;
        break;
      case 'P2AddressLine1':
        p2ParentDetailsErrors.AddressLine1 = apiErrorMsg;
        break;
      case 'P2AddressLine2':
        p2ParentDetailsErrors.AddressLine2 = apiErrorMsg;
        break;
      case 'P2SuburbTownCity':
        p2ParentDetailsErrors.SuburbTownCity = apiErrorMsg;
        break;
      case 'P2StateProvinceRegion':
        p2ParentDetailsErrors.StateProvinceRegion = apiErrorMsg;
        break;
      case 'P2Postcode':
        p2ParentDetailsErrors.Postcode = apiErrorMsg;
        break;
      case 'P2CountryId':
        p2ParentDetailsErrors.CountryId = apiErrorMsg;
        break;

      //Legal custodian
      case 'LCRelationshipCode':
        lcParentInfoErrors.Relationship = apiErrorMsg;
        break;
      case 'LCOtherRelationship':        
        lcParentInfoErrors.OtherRelationship = apiErrorMsg;
        break;
      case 'LCGivenName':
        lcParentInfoErrors.GivenName = apiErrorMsg;
        break;
      case 'LCFamilyName':
        lcParentInfoErrors.FamilyName = apiErrorMsg;
        break;
      case 'LCHasLegalCustody':
        lcParentInfoErrors.HasLegalCustody = apiErrorMsg;
        break;

      case 'LCIsRefusedAusVisaBefore':
        lcParentDetailsErrors.IsRefusedAusVisaBefore = apiErrorMsg;
        break;
      case 'LCVisaRefusalDetails':
        lcParentDetailsErrors.VisaRefusalDetails = apiErrorMsg;
        break;
      case 'LCGender':
        lcParentDetailsErrors.Gender = apiErrorMsg;
        break;
      case 'LCDateOfBirth':
        lcParentDetailsErrors.DateOfBirth = apiErrorMsg;
        break;
      case 'LCCountryOfBirthId':
        lcParentDetailsErrors.CountryOfBirthId = apiErrorMsg;
        break;
      case 'LCCountryOfNationalityId':
        lcParentDetailsErrors.CountryOfNationalityId = apiErrorMsg;
        break;
      case 'LCPassportNumber':
        lcParentDetailsErrors.PassportNumber = apiErrorMsg;
        break;
      case 'LCEmailAddress':
        lcParentDetailsErrors.EmailAddress = apiErrorMsg;
        break;
      case 'LCMobileCountryCode':
        lcParentDetailsErrors.MobileCountryCode = apiErrorMsg;
        break;
      case 'LCMobilePhoneNumber':
        lcParentDetailsErrors.MobilePhoneNumber = apiErrorMsg;
        break;
      case 'LCHomeCountryCode':
        lcParentDetailsErrors.HomeCountryCode = apiErrorMsg;
        break;
      case 'LCHomePhoneNumber':
        lcParentDetailsErrors.HomePhoneNumber = apiErrorMsg;
        break;
      case 'LCIsAustralianAddress':
        lcParentDetailsErrors.IsAustralianAddress = apiErrorMsg;
        break;
      case 'LCAddressLine1':
        lcParentDetailsErrors.AddressLine1 = apiErrorMsg;
        break;
      case 'LCAddressLine2':
        lcParentDetailsErrors.AddressLine2 = apiErrorMsg;
        break;
      case 'LCSuburbTownCity':
        lcParentDetailsErrors.SuburbTownCity = apiErrorMsg;
        break;
      case 'LCStateProvinceRegion':
        lcParentDetailsErrors.StateProvinceRegion = apiErrorMsg;
        break;
      case 'LCPostcode':
        lcParentDetailsErrors.Postcode = apiErrorMsg;
        break;
      case 'LCCountryId':
        lcParentDetailsErrors.CountryId = apiErrorMsg;
        break;

    }
  }

  /* For accessibility, keyboard only design, use tab to show borders but showing no border by clicking on mouse */
  keyboardFocus(event): void {
    event.style.outline = "1px solid blue";
  }

  keyboardBlur(event): void {
    event.style.outline = "";
  }
}
